import React, { useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ReactCSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import MainWindow from "apps/messenger/components/MainWindow";
import OverflowMenu from "apps/messenger/components/OverflowMenu";

import { WINDOW_STATE } from "apps/messenger/util/consts";

import "apps/messenger/components/App.scss";

const SLIDE_IN_SPEED = 400;

function getConversationMetadata(order, data) {
	const conversationsToShow = order
		.filter((userId) => data[userId] && (
			data[userId].state !== WINDOW_STATE.Overflow
		))
		.map((userid) => data[userid]);

	const conversationsToHide = order
		.filter((userId) => data[userId] && (
			data[userId].state === WINDOW_STATE.Overflow
		))
		.map((userid) => data[userid]);

	const hasOpenWindows = conversationsToShow.some(({ state }) => state === WINDOW_STATE.Open);

	return {
		conversationsToShow,
		conversationsToHide,
		hasOpenWindows,
	};
}

const App = ({
	conversationOrder,
	conversationData,
	stateLoading,
	setupMessenger,

	...otherProps
}) => {
	// Run on mount.
	useEffect(setupMessenger, []);

	// Get info about conversations
	const {
		conversationsToShow,
		conversationsToHide,
		hasOpenWindows,
	} = useMemo(
		() => getConversationMetadata(conversationOrder, conversationData),
		[conversationOrder, conversationData],
	);

	// Exit if we don't have conversations to show.
	if (stateLoading || !conversationOrder.length) {
		return null;
	}

	return (
		<ReactCSSTransitionGroup
			component={React.Fragment}
			transitionName="slide-in-transition"
			transitionAppear={!hasOpenWindows}
			transitionEnter={!hasOpenWindows}
			transitionLeave={false}
			transitionAppearTimeout={SLIDE_IN_SPEED}
			transitionEnterTimeout={SLIDE_IN_SPEED}>
			<div className={classnames("messenger", {
				"messenger--mobile": process.env.PLATFORM === "mobile",
			})}>
				{conversationsToShow.length > 0 && conversationsToShow.map((conversationToShow) => (
					<MainWindow
						key={conversationToShow.fields.userid}
						{...conversationToShow}
						{...otherProps}
					/>
				))}

				{conversationsToHide.length > 0 && (
					<OverflowMenu
						conversations={conversationsToHide}
						openConversation={otherProps.openConversation}
						closeConversation={otherProps.closeConversation}
					/>
				)}
			</div>
		</ReactCSSTransitionGroup>
	);
};

App.propTypes = {
	conversationOrder: PropTypes.array.isRequired,
	conversationData: PropTypes.object.isRequired,
	stateLoading: PropTypes.bool.isRequired,

	setupMessenger: PropTypes.func.isRequired,
	loadMessages: PropTypes.func.isRequired,
	openConversation: PropTypes.func.isRequired,
	minimizeConversation: PropTypes.func.isRequired,
	closeConversation: PropTypes.func.isRequired,
	updateDraft: PropTypes.func.isRequired,
	sendMessage: PropTypes.func.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/App.jsx